import React, { useId } from 'react';

function FormField({ label, required, hint, error, children }) {
  const generatedId = useId();
  const child = React.isValidElement(children)
    ? React.cloneElement(children, {
        id: children.props.id || generatedId,
        'aria-invalid': error ? 'true' : undefined,
        'aria-describedby': error ? `${generatedId}-error` : hint ? `${generatedId}-hint` : undefined,
      })
    : children;

  return (
    <div className="form-field">
      {label && (
        <label className="form-field-label" htmlFor={children?.props?.id || generatedId}>
          {label}
          {required && <span className="form-field-required">*</span>}
        </label>
      )}
      {child}
      {error ? (
        <span id={`${generatedId}-error`} className="form-field-error">{error}</span>
      ) : hint ? (
        <span id={`${generatedId}-hint`} className="form-field-hint">{hint}</span>
      ) : null}
    </div>
  );
}

export default FormField;
